// Helpers for Instagram-type contacts.
//
// Instagram contacts (created by the instagram-login inbox) store the user's
// @handle in `nome` and a unique Instagram id in `codigo`. The UI must never
// expose the raw `codigo`; it shows the @handle instead, and the identifier is
// not editable.

export const TIPO_CONTATO_INSTAGRAM = 'INSTAGRAM';
export const TIPO_CONTATO_FACEBOOK = 'FACEBOOK';

export function isInstagramContato(tipo?: string | null): boolean {
    return (tipo ?? '').toUpperCase() === TIPO_CONTATO_INSTAGRAM;
}

/** Messenger (MESSENGER_META) grava o contato com tipo FACEBOOK. */
export function isFacebookContato(tipo?: string | null): boolean {
    return (tipo ?? '').toUpperCase() === TIPO_CONTATO_FACEBOOK;
}

/**
 * Normalizes an Instagram handle into a single leading-@ form for display.
 * `nome` holds the handle; we strip any leading @ and re-add exactly one.
 */
export function instagramHandle(nome?: string | null): string {
    const raw = (nome ?? '').trim().replace(/^@+/, '');
    return raw ? `@${raw}` : '';
}

/** Strips leading @ and surrounding whitespace from a typed handle. */
export function normalizeInstagramHandle(handle?: string | null): string {
    return (handle ?? '').trim().replace(/^@+/, '');
}
